import mitt from 'mitt';

export const events = mitt(); // 发布订阅对象
